import "./DealStructure.css";

import { GetDealResponse } from "../../../../../service/query";
import { ServiceError } from "../../../../../service/Shared";
import { Column, ErrorBox, Row } from "../../../../../widget";
import { AssociationsDetails, DealStructureList, InvestmentDetails } from "./components";
import { useDealStructure } from "./useDealStructure";

interface DealStructureProps {
  deal: GetDealResponse | undefined;
  canEdit: boolean;
  onDealStructureSaved: () => Promise<void>;
}

const DealStructure = ({ deal, canEdit, onDealStructureSaved }: DealStructureProps): JSX.Element => {
  const {
    errors,
    isEditing,
    isSaving,
    instrumentSelectData,
    associationSelectData,
    hasValidationError,
    selectedInvestmentKey,
    setSelectedInvestmentKey,
    dealStructureItems,
    selectedInvestment,
    dealSpecificSchemaProperties,
    selectedCompany,
    selectedProjects,
    selectedLandholdings,
    onUpdateInvestment,
    onRemoveInvestment,
    onAddInvestment,
    startEditing,
    cancelEditing,
    saveDealStructure,
  } = useDealStructure(deal, onDealStructureSaved);

  return (
    <>
      {errors && errors.length > 0 && (
        <Row spacingV="ml">
          <Column span={12}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <div className="DealStructureContent">
        <DealStructureList
          isEditing={isEditing}
          isSaving={isSaving}
          selectedInvestmentKey={selectedInvestmentKey}
          setSelectedInvestmentKey={setSelectedInvestmentKey}
          dealStructureItems={dealStructureItems}
          onRemoveInvestment={onRemoveInvestment}
          onAddInvestment={onAddInvestment}
          startEditing={startEditing}
          cancelEditing={cancelEditing}
          saveDealStructure={saveDealStructure}
          canEdit={canEdit}
        />
        <div className="DealStructureDetails">
          <InvestmentDetails
            isEditing={isEditing}
            selectedInvestment={selectedInvestment}
            instrumentSelectData={instrumentSelectData}
            associationSelectData={associationSelectData}
            dealSpecificSchemaProperties={dealSpecificSchemaProperties}
            hasValidationError={hasValidationError}
            onUpdateInvestment={onUpdateInvestment}
          />
          <AssociationsDetails
            selectedCompany={selectedCompany}
            selectedProjects={selectedProjects}
            selectedLandholdings={selectedLandholdings}
          />
        </div>
      </div>
    </>
  );
};

export default DealStructure;
